import {
  checkoutOptimizationInvoiceSchema,
  checkoutOptimizationSubscriptionInvoiceSchema,
} from "@redotech/redo-billing-common/service-invoice";
import * as z from "zod";

export const getFinalizedServiceInvoices = {
  name: "getFinalizedServiceInvoices" as const,
  input: z.null(),
  output: z.array(
    z.union([
      checkoutOptimizationInvoiceSchema,
      checkoutOptimizationSubscriptionInvoiceSchema,
    ]),
  ),
};
